import { createCRUDService, fetchDropdowns } from './createCRUDService';
import { api } from './api';
import { CHILDREN, DROPDOWNS, UPLOAD, VACCINATION_RECORD, buildUrl } from './api/endpoints';

// Create base CRUD service for patients (list from patients, CRUD from admin/parents)
const baseCRUD = createCRUDService(CHILDREN.BASE);

// Export service with additional custom methods
export const ChildrenService = {
    ...baseCRUD,
    getDropdowns: () => fetchDropdowns(DROPDOWNS.BASE),

  // Children management
  getChildren: async ({ page = 1, limit = 5, parentId = '', search = '' } = {}) => {
    const params = { page, limit };
    if (parentId) params.parentId = parentId;
    if (search) params.search = search;

    const response = await api.get(buildUrl(CHILDREN.ALL, params));
    return response.data;
  },

  getChildById: (id) => baseCRUD.getById(id),
  createChild: (data) => baseCRUD.create(data),
  updateChild: (id, data) => baseCRUD.update(id, data),
  deleteChild: (id) => baseCRUD.delete(id),

  // Profile photo upload
  uploadProfilePhoto: async (formData) => {
    const response = await api.upload(UPLOAD.PROFILE_PHOTO, formData);
    return response.data;
  },

  // Get vaccination records by child ID
  getVaccinationRecords: async (childId, { page = 1, limit = 10 } = {}) => {
    const response = await api.get(VACCINATION_RECORD.BY_CHILD(childId, page, limit));
    return response.data;
  },

  // Age-based vaccination plan
  getVaccinationPlan: async (childId) => {
    const response = await api.get(CHILDREN.VACCINATION_PLAN(childId));
    return response.data;
  },

  markPlanItemCompleted: async (childId, planId, data) => {
    const response = await api.patch(CHILDREN.VACCINATION_PLAN_ITEM(childId, planId), data);
    return response.data;
  },

  listVaccinationPlans: async (params = {}) => {
    const response = await api.get(buildUrl(CHILDREN.VACCINATION_PLANS_LIST, params));
    return response.data;
  },
};

export default ChildrenService;
